export const BROWSER_PERSISTED_STORAGE_PREFIX = 'browser:';

function clearStorageExceptBrowserPersistedKeys(storage: Storage) {
  const preservedEntries: [string, string][] = [];

  Array.from({ length: storage.length }).forEach((_, index) => {
    const key = storage.key(index);
    const value = key ? storage.getItem(key) : null;

    if (key?.startsWith(BROWSER_PERSISTED_STORAGE_PREFIX) && value !== null) {
      preservedEntries.push([key, value]);
    }
  });

  storage.clear();

  preservedEntries.forEach(([key, value]) => {
    storage.setItem(key, value);
  });
}

export function clearLocalStorageExceptBrowserPersistedKeys() {
  clearStorageExceptBrowserPersistedKeys(localStorage);
}

export function clearSessionStorageExceptBrowserPersistedKeys() {
  clearStorageExceptBrowserPersistedKeys(sessionStorage);
}
